var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Img(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 557.613,
    height: 301.427,
    viewBox: "0 0 557.613 301.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.105,
    y1: 0.474,
    x2: 1.102,
    y2: 0.474,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51397f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.181,
    y1: 0.496,
    x2: 0.772,
    y2: 0.496,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1dae5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.022,
    y1: 0.204,
    x2: 1.149,
    y2: 0.204,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.195,
    y1: 0.445,
    x2: 0.973,
    y2: 0.445,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.146,
    y1: 0.462,
    x2: 1.091,
    y2: 0.462,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.007,
    y1: 0.466,
    x2: 1.123,
    y2: 0.466,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.008,
    y1: 0.536,
    x2: 1.024,
    y2: 0.536,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.167,
    y1: 0.42,
    x2: 0.187,
    y2: 0.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.421,
    y1: -0.025,
    x2: 0.993,
    y2: 0.639,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.117,
    y1: -0.295,
    x2: 0.582,
    y2: 1.265,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.155,
    y1: 0.536,
    x2: 0.849,
    y2: 0.536,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.019,
    y1: 0.629,
    x2: 1.238,
    y2: 0.482,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2c5e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.558,
    y1: 0.066,
    x2: 1.214,
    y2: 0.889,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed202e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.473,
    y1: -0.033,
    x2: 0.86,
    y2: 0.619,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.114,
    y1: 0.523,
    x2: 0.885,
    y2: 0.467,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a193ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.678,
    y1: 0.9,
    x2: 0.573,
    y2: -0.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.18,
    y1: 0.996,
    x2: 0.713,
    y2: 0.293,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cec4d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cec4d6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1.5,
    y1: 0.902,
    x2: 1.147,
    y2: 0.154,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34254c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#432a68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1.476,
    y1: 0.914,
    x2: 1.125,
    y2: 0.173,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 2.022,
    y1: 1.391,
    x2: 1.715,
    y2: -0.045,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1.035,
    y1: 1.215,
    x2: 1.92,
    y2: 0.266,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3492b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc8e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.987,
    y1: 0.592,
    x2: 1.99,
    y2: 0.592,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d733db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f43ef9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.586,
    y1: 0.722,
    x2: 1.491,
    y2: 0.488,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1e45a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2265c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.172,
    y1: 0.622,
    x2: 1.135,
    y2: 0.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.173,
    y1: 0.498,
    x2: 1.179,
    y2: 0.498,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1.415,
    y1: 0.347,
    x2: 1.002,
    y2: 0.408,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1.196,
    y1: 0.544,
    x2: 1.569,
    y2: 0.498,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.757,
    y1: 0.277,
    x2: 1.763,
    y2: 0.277,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.258,
    y1: 0.579,
    x2: 1.142,
    y2: 0.238,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.618,
    y1: 0.882,
    x2: 0.896,
    y2: -0.032,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8b8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8b8d3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.377,
    y1: 0.822,
    x2: 0.924,
    y2: 0.502,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.123,
    y1: 0.588,
    x2: 1.293,
    y2: 0.33,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524b56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -0.041,
    y1: 0.504,
    x2: 0.643,
    y2: 0.462,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#111011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111011",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.786,
    y1: -0.24,
    x2: 1.123,
    y2: 1.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ede7f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ede7f2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1.98,
    y1: -0.596,
    x2: 4.067,
    y2: 2.281,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.041,
    y1: 0.649,
    x2: 1.07,
    y2: 0.649,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.895,
    y1: 0.807,
    x2: 0,
    y2: -0.397,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1.467,
    y1: 1.184,
    x2: 1.033,
    y2: 0.128,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.941,
    y1: 0.342,
    x2: 2.089,
    y2: 0.342,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.18,
    y1: 0.661,
    x2: 1.164,
    y2: 0.232,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1.084,
    y1: 0.736,
    x2: 0.41,
    y2: 0.179,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.943,
    y1: -0.105,
    x2: 1.916,
    y2: -0.105,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.805,
    y1: -0.175,
    x2: 1.8,
    y2: -0.175,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.475,
    y1: -0.092,
    x2: 1.443,
    y2: -0.092,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.334,
    y1: -0.244,
    x2: 1.316,
    y2: -0.244,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 2.21,
    y1: -0.743,
    x2: 1.065,
    y2: 0.681,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1.733,
    y1: 0.654,
    x2: 0.61,
    y2: 0.381,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1.338,
    y1: 0.663,
    x2: 1.527,
    y2: -0.369,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1.269,
    y1: -0.43,
    x2: 2.294,
    y2: -0.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.925,
    y1: -0.367,
    x2: 1.927,
    y2: -0.367,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 0.96,
    y1: -0.366,
    x2: 1.961,
    y2: -0.366,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.675,
    y1: -0.422,
    x2: 1.674,
    y2: -0.422,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -25.561,
    y1: 1.554,
    x2: -26.199,
    y2: 0.975,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -158.247,
    y1: 4.182,
    x2: -157.189,
    y2: 4.182,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -142.446,
    y1: 4.675,
    x2: -141.437,
    y2: 4.675,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -102.405,
    y1: 3.609,
    x2: -101.355,
    y2: 3.609,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -82.697,
    y1: 4.204,
    x2: -81.651,
    y2: 4.204,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -158.392,
    y1: 1.669,
    x2: -159.28,
    y2: 3.152,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -49.802,
    y1: 1.477,
    x2: -50.653,
    y2: 1.189,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -132.181,
    y1: 5.043,
    x2: -131.994,
    y2: 4.016,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -194.002,
    y1: 6.759,
    x2: -193.033,
    y2: 6.759,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -161.589,
    y1: 5.756,
    x2: -160.599,
    y2: 5.756,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -198.146,
    y1: 5.51,
    x2: -197.164,
    y2: 5.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -166.478,
    y1: 5.977,
    x2: -165.468,
    y2: 5.977,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -0.062,
    y1: 0.552,
    x2: 1.016,
    y2: 0.552,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -0.149,
    y1: 0.934,
    x2: 1.059,
    y2: 0.323,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbaec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ded1e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -30.339,
    y1: 20.459,
    x2: -29.691,
    y2: 20.459,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 0.082,
    y1: 0.482,
    x2: 0.959,
    y2: 0.306,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.922,
    y1: 0.314,
    x2: 0.142,
    y2: 0.721,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.851,
    y1: 0.293,
    x2: 0.077,
    y2: 0.843,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04074a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04074a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_404-img",
    "data-name": "404-img",
    transform: "translate(-413.353 -306.069)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4118",
    "data-name": "Path 4118",
    d: "M-318.647-74.013v-34.982l101.058-136.04h45.147v134.545h27.507v36.477h-27.507v42.456H-214.9V-74.013ZM-211.609-195.7l-63.983,85.212h63.983Zm90.294,56.808q0,107.337,80.727,107.337,42.755,0,61.592-28.7T39.84-138.893q0-49.632-18.836-78.335t-61.592-28.7Q-121.315-245.931-121.315-138.893Zm119.6,0q0,32.59-7.923,50.081T-40.588-71.322q-23.321,0-31.244-17.491t-7.923-50.081q0-32.291,7.923-49.782t31.244-17.491q23.022,0,30.945,17.491T-1.719-138.893Zm66.973,64.88v-34.982l101.058-136.04h45.147v134.545h27.507v36.477H211.459v42.456H169V-74.013ZM172.292-195.7l-63.983,85.212h63.983Z",
    transform: "translate(732 552)",
    fill: "#150958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(582.152 320.583)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M42.792,59.2s-4.358-13.171-2.943-15.138S60.5,33.8,85.068,28.582s25.723-3.252,27.642-1.837,4.211,16.423,4.163,19.512S42.792,59.2,42.792,59.2Z",
    transform: "translate(24.804 15.765)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M171.547,156.458l-1.626,3.756L158,186.474,146.62,211.628c-5.675-3.984-7.431-18.52-7.154-29.593a89.268,89.268,0,0,0-1.268-18.406,24.39,24.39,0,0,1-8.358-7.382,45.628,45.628,0,0,1-3.366-5.236h0c-.715-1.333-1.106-2.2-1.106-2.2-13.317.65-22.39-7.984-24.536-9.366s-6.179-.1-10.195,8.91c-3.61,8.13-12.748,11.382-14.536,11.967l-.309.1c-.39,2.179-.8,4.146-1.22,5.919-3.415,14.358-7.545,16.26-7.545,16.26-.455,4.65,2.309,11.382,3.154,20.081a170.427,170.427,0,0,1,0,22.114L58.2,217.351,34.638,202.815s-8.894-20.992-8.341-27.967a19.772,19.772,0,0,1,1.187-5.3,25.285,25.285,0,0,1,2.26-4.6h0a17.189,17.189,0,0,1,1.626-2.26s0-1.122,0-2.878a20.174,20.174,0,0,1,.13-2.667,52.244,52.244,0,0,1,1.024-7.4,16.892,16.892,0,0,1,.634-1.886,20.583,20.583,0,0,1,1.35-3.089,25.429,25.429,0,0,1,1.626-2.537h0l.13-.179.13-.163.455-.585c.992-1.22,1.756-1.935,1.8-2h0s.52-1.837,1.236-4.471c.553-2.032,1.219-4.537,1.837-7.041,1.4-5.756,1.252-7.8,4.878-10.618s4.488-5.122,6.618-6.8h.1c1.236-.943,3.5-2.374,5.236-3.431h0c1.35-.829,2.39-1.431,2.39-1.431a22.943,22.943,0,0,1,1.48-7.919A9.561,9.561,0,0,1,61.4,95.158c-.341-1.089-.569-2.081-.569-2.081-.6.407-1.171.764-1.74,1.089h0c-6.244,3.528-10.634,2.309-10.634,2.309a24.017,24.017,0,0,1-4.878,1.48,22.39,22.39,0,0,1-6.276.309A30.487,30.487,0,0,1,19.76,89.694l5.4-7.658,11.935-16.91a14.049,14.049,0,0,1,4.764,1.707h0q.553.358.976.683h0l.423.374a4.878,4.878,0,0,1,1.008,1.268h0a.163.163,0,0,1,0,.081h0a10.161,10.161,0,0,1,.146-1.106,7.171,7.171,0,0,1,.7-2.049l.2-.325a4.634,4.634,0,0,1,1.089-1.236,3.366,3.366,0,0,1,1.4-.569,3.007,3.007,0,0,1,.114-1.008c1.626-12.471,9.756-12.764,9.756-12.764,1.626-9.366,11.171-9.512,11.171-9.512s2.016.488,5.187.927h0a65.365,65.365,0,0,0,20.553-.1,28.471,28.471,0,0,0,15.788-8.78,19.513,19.513,0,0,0,1.724-2.2c7.837-1.8,13.9,8.13,13.9,8.13,4.5,0,8.13,3.008,10.162,5.252a20.116,20.116,0,0,1,1.935,2.406l.146-.2a12.129,12.129,0,0,1,1.626-1.724h0l.309-.26h0a15.642,15.642,0,0,1,2.894-1.8,17.756,17.756,0,0,1,4.537-1.512L158.36,62.524l2.211,4.683a16.374,16.374,0,0,1-8.715,10.634,21.515,21.515,0,0,1-2.13.943,14.633,14.633,0,0,1-1.626.488c-5.935,1.382-12.471-1.268-16.26-3.252h0l-.146-.081h-.1a1.139,1.139,0,0,1-.228-.13A26.7,26.7,0,0,1,128.8,74.3a19.058,19.058,0,0,1,.878,3.252h0a1.316,1.316,0,0,0,.114.65,38,38,0,0,1,.2,9.756,31.9,31.9,0,0,1,1.821,7.431,7.187,7.187,0,0,1-.65,4.732v.1l.6-.325h0a13.159,13.159,0,0,1,2.211-.829l.423-.1h0c.5-.1,1.089-.179,1.724-.244h0a22.2,22.2,0,0,1,9.236,1.333h0l.293.114.553.2c9.756,3.707,13.9,19.366,13.9,19.366a16.748,16.748,0,0,1,4.341,4.553,29.089,29.089,0,0,1,5.122,13.561C170.392,147.027,171.547,156.458,171.547,156.458Z",
    transform: "translate(12.406 18.977)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M37.284,78.357A30.487,30.487,0,0,1,19.74,69.788l5.4-7.658a22.374,22.374,0,0,0,11.577,8.049,17.4,17.4,0,0,0,5.4.472A26.374,26.374,0,0,1,37.284,78.357Z",
    transform: "translate(12.393 38.899)",
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M119.569,79.341l-8.13,12.341s-7.171,11.577-20.618,10.439S65.2,88.707,55.554,94.251s-15.219,18-15.219,18l5.545-1.626s-9.756,6.5-11.5,10.52a1.854,1.854,0,0,0,.293,2.325l-5.886,1.724a25.431,25.431,0,0,1,1.626-2.537h0l.13-.179.13-.163.455-.585c.992-1.22,1.756-1.935,1.8-2h0s.52-1.837,1.236-4.471c.553-2.032,1.219-4.537,1.837-7.041,1.4-5.756,1.252-7.8,4.878-10.618s4.488-5.122,6.618-6.8h.1c1.236-.943,3.5-2.374,5.236-3.431h0c1.35-.829,2.39-1.431,2.39-1.431a22.943,22.943,0,0,1,1.545-7.967,9.561,9.561,0,0,1-1.024-2.439c-.341-1.089-.569-2.081-.569-2.081-.6.407-1.171.764-1.74,1.089h0c-6.244,3.528-10.634,2.309-10.634,2.309a24.017,24.017,0,0,1-4.878,1.48A28.455,28.455,0,0,0,40.92,69.91a12.26,12.26,0,0,0,3.366-1.9,6.683,6.683,0,0,0,5.789,1.919c4.1-.276,12.065-3.9,12.032-8.276A28.764,28.764,0,0,0,81.667,81.406C97.944,86.463,112.789,81.861,119.569,79.341Z",
    transform: "translate(18.059 38.599)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M52.641,133.052c-.455,4.65,2.309,11.382,3.154,20.081a170.425,170.425,0,0,1,0,22.114L43.812,167.8c2.8-7.626-.829-19.122-1.2-27.642-.455-10.5,5.935-10.943,5.935-10.943a17.723,17.723,0,0,1,5.48-19.675,37.121,37.121,0,0,1,6.163,7.252C56.771,131.1,52.641,133.052,52.641,133.052Z",
    transform: "translate(26.695 68.578)",
    fill: "url(#linear-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M111.2,100.91a42.1,42.1,0,0,0-5.041,11.772c-.715-1.333-1.106-2.2-1.106-2.2-13.317.65-22.39-7.984-24.536-9.366s-6.179-.1-10.195,8.91c-3.61,8.13-12.748,11.382-14.536,11.967-.764-.976-2.049-2.569-3.74-4.423,3.154-3.122,5.772-7.561,10.1-14.439a23.528,23.528,0,0,1,16.26-11.382c5.577-1.154,8.13,2.276,20.829,7.821A19.756,19.756,0,0,0,111.2,100.91Z",
    transform: "translate(32.619 57.305)",
    fill: "url(#linear-gradient-6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M115.572,144.779,104.19,169.933c-5.675-3.984-7.431-18.52-7.154-29.593a89.268,89.268,0,0,0-1.268-18.406,24.39,24.39,0,0,1-8.358-7.382A100.812,100.812,0,0,1,98.288,96.91c-1.821,7.415,1.772,13.171,6.016,18.276a75.185,75.185,0,0,0,.943,21.268C106.662,142.861,112.011,144.454,115.572,144.779Z",
    transform: "translate(54.754 60.671)",
    fill: "url(#linear-gradient-7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M123.076,129.568l-1.626,3.756c-3.252-3.593-6.016-11.187-7.48-21.626-2-14.26-10.8-16.26-10.8-16.26C106.67,84.057,98.7,74.87,97.19,73.26l.553.2c9.756,3.707,13.9,19.366,13.9,19.366a16.748,16.748,0,0,1,4.341,4.553,29.089,29.089,0,0,1,5.122,13.561C121.921,120.137,123.076,129.568,123.076,129.568Z",
    transform: "translate(60.877 45.866)",
    fill: "url(#linear-gradient-8)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M54.192,44.68c.862,5.089,9.366,5.268,9.366,5.268-5.284,1.626-9.756,1.187-15.154.276s-9.154,8.845-7.675,9.48,2.894,3.171,2.894,3.171c-4.26-2.016-4.878.081-3.545,4.618A39.69,39.69,0,0,1,40.859,79c-.829-4.715-3.935-11.089-5.919-14.845a7.171,7.171,0,0,1,.7-2.049l.2-.325a4.634,4.634,0,0,1,1.089-1.236,3.366,3.366,0,0,1,1.366-.585,3.007,3.007,0,0,1,.114-1.008c1.626-12.471,9.756-12.764,9.756-12.764C49.785,36.826,59.33,36.68,59.33,36.68s2.016.488,5.187.927C60.582,37.038,53.33,39.607,54.192,44.68Z",
    transform: "translate(21.908 22.968)",
    fill: "url(#linear-gradient-9)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M103.308,46l-.2.976A17.219,17.219,0,0,0,89.5,41.98C88.528,46.419,80.87,47.2,80.87,47.2s5.951-3.252,5.171-7.041-10.52-7.236-10.52-7.236v-.244a19.513,19.513,0,0,0,1.724-2.2c7.837-1.8,13.9,8.13,13.9,8.13,4.5,0,8.13,3.008,10.162,5.252a20.114,20.114,0,0,1,1.935,2.406Z",
    transform: "translate(47.311 18.952)",
    fill: "url(#linear-gradient-10)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M34.738,104c-.179.423-6,14.439-10.228,19.366h0a25.284,25.284,0,0,1,2.26-4.6h0A17.189,17.189,0,0,1,28.4,116.5s0-1.122,0-2.878a20.173,20.173,0,0,1,.13-2.667A20.016,20.016,0,0,0,34.738,104Z",
    transform: "translate(15.379 65.11)",
    fill: "#cec4d6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M105.734,63.318a43.741,43.741,0,0,0,4.341,7.268c-5.935,1.382-12.471-1.268-16.26-3.252h0l-.146-.081h-.1a1.139,1.139,0,0,1-.228-.13,26.7,26.7,0,0,1-2.569-1.512,19.057,19.057,0,0,1,.878,3.252h0a1.317,1.317,0,0,0,.114.65C84.141,58.9,80.743,44.977,80.58,44.31c.244.667,5.122,14.39,16.91,18.1a20.862,20.862,0,0,0,8.244.911Z",
    transform: "translate(50.479 27.744)",
    fill: "#e5dfe9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M111.293,54.8a16.374,16.374,0,0,1-8.715,10.634,39.12,39.12,0,0,1-4.1-6.683,20.666,20.666,0,0,0,10.6-8.634Z",
    transform: "translate(61.684 31.381)",
    fill: "#e5dfe9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M114.952,74.049h0s-10.91,6.114-12.667,8.13-3.252,4.959-11.658,7.528a58.029,58.029,0,0,1-7.089,1.626C76.172,92.6,67.083,92.6,59.668,88.439a21.252,21.252,0,0,0-9.528-7.9,75.071,75.071,0,0,0,9.87,1.528h.927a12.666,12.666,0,0,0,1.382,0,4.878,4.878,0,0,1,1.626-1.4,25.9,25.9,0,0,1,6.179-.358H71.31A43.735,43.735,0,0,0,77,80.048c2.016-.26,3.528-.358,5.106-.569l1.2-.163c2.8-.406,4.878-.8,5.415-.829a4.276,4.276,0,0,1,2.943,1.106l.228.211.78-.276c.943-.341,2.667-.976,4.732-1.789l.894-.358,1.854-.748.667-.276h0c1.626-.65,3.252-1.366,4.878-2.114l.5-.244a47.282,47.282,0,0,0,6.715-3.74v1.057a6.179,6.179,0,0,1-.715,3.675v.1l.6-.325h0A13.156,13.156,0,0,1,114.952,74.049Z",
    transform: "translate(31.424 43.989)",
    fill: "url(#linear-gradient-11)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M112.985,71.317c-2.683,1.626-12.39,7.366-20.179,9.333l-.13,3.431c0-.374-.1-4.276-8.13-3.008a123.722,123.722,0,0,1-16.618,1.4s2.26,9.935,15.512,8.878C76.172,92.6,67.083,92.6,59.668,88.439a21.252,21.252,0,0,0-9.528-7.9,75.071,75.071,0,0,0,9.87,1.528h.927a12.666,12.666,0,0,0,1.382,0,4.878,4.878,0,0,1,1.626-1.4,25.9,25.9,0,0,1,6.179-.358H71.31A43.735,43.735,0,0,0,77,80.048c2.016-.26,3.528-.358,5.106-.569l1.2-.163c2.8-.406,4.878-.8,5.415-.829a4.276,4.276,0,0,1,2.943,1.106l.228.211.78-.276c.943-.341,2.667-.976,4.732-1.789l.894-.358,1.854-.748.667-.276h0c1.626-.65,3.252-1.366,4.878-2.114l.5-.244a47.282,47.282,0,0,0,6.715-3.74C112.952,70.634,112.985,70.992,112.985,71.317Z",
    transform: "translate(31.424 43.989)",
    fill: "url(#linear-gradient-12)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M63.653,76.44V87.107l-1.2-10.65Z",
    transform: "translate(39.13 47.857)",
    fill: "#5c479e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M71.033,75.83l-.472,10.878L69.83,75.993Z",
    transform: "translate(43.749 47.475)",
    fill: "#5c479e"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M57.117,77.569,56.5,82.04l-.309-4.52C56.5,77.553,56.808,77.553,57.117,77.569Z",
    transform: "translate(35.211 48.534)",
    fill: "#5c479e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M76.194,83.927a75.222,75.222,0,0,0-.5-7.9l.228.211.78-.276A32,32,0,0,1,76.194,83.927Z",
    transform: "translate(47.418 47.557)",
    fill: "#5c479e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M80.134,74.64l-.455,6.65L79.24,75Z",
    transform: "translate(49.64 46.73)",
    fill: "#5c479e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M81.6,74l-.341,4.878-.325-4.65Z",
    transform: "translate(50.698 46.33)",
    fill: "#5c479e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M84.814,72.56l-.26,3.821L84.31,72.8Z",
    transform: "translate(52.814 45.428)",
    fill: "#5c479e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M73.663,88.355C68.134,89.981,61.6,77.1,50.9,78.1A35.983,35.983,0,0,0,40.46,81.185h.1c1.236-.943,3.5-2.374,5.236-3.431h0a20.861,20.861,0,0,1,9.349-1.138C62.866,76.924,68.232,87.7,73.663,88.355Z",
    transform: "translate(25.364 47.893)",
    fill: "#aca5b5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M108.337,73.73C93.166,71.779,78.89,86.9,78.89,86.9c6.228-8.032,11.691-11.626,15.382-13.219l.52-.228h0a19.253,19.253,0,0,1,2.5-.8h0a8.13,8.13,0,0,1,1.724-.244h0A22.2,22.2,0,0,1,108.337,73.73Z",
    transform: "translate(49.421 45.299)",
    fill: "#aca5b5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M29.77,99.14Z",
    transform: "translate(18.672 62.068)",
    fill: "#aca5b5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M45.224,91.75A39.951,39.951,0,0,0,29.81,103.685a22.765,22.765,0,0,1,2.667-3.106s.52-1.837,1.236-4.471A59.38,59.38,0,0,1,45.224,91.75Z",
    transform: "translate(18.697 57.441)",
    fill: "#aca5b5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M30.707,108a29.674,29.674,0,0,1-4.8,8.39,17.19,17.19,0,0,1,1.626-2.26s0-1.122,0-2.878A10.65,10.65,0,0,0,30.707,108Z",
    transform: "translate(16.256 67.614)",
    fill: "#aca5b5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M95.68,39.068c-.585.537-5.431,5.415-3.951,20.065,0,0-3.089-10.975.179-20.553a20.114,20.114,0,0,1,1.935,2.406A11.382,11.382,0,0,1,95.68,39.068Z",
    transform: "translate(56.631 24.157)",
    fill: "#c0b8cc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M93.66,38.87Z",
    transform: "translate(58.667 24.339)",
    fill: "#aca5b5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M35.371,54.846A11.741,11.741,0,0,0,33.94,53.22,5.3,5.3,0,0,1,35.371,54.846Z",
    transform: "translate(21.282 33.322)",
    fill: "#aca5b5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M40.915,69.214c-2.341-7.545-4.5-11.593-6.065-13.74h0A8.13,8.13,0,0,1,35.7,52.32a57.04,57.04,0,0,1,5.219,16.894Z",
    transform: "translate(21.852 32.758)",
    fill: "#aca5b5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M42.794,53.534a6.78,6.78,0,0,0-6.634-1.626,3.366,3.366,0,0,1,1.366-.52,3.007,3.007,0,0,1,.114-1.008A8.13,8.13,0,0,1,42.794,53.534Z",
    transform: "translate(22.672 31.544)",
    fill: "#aca5b5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M52.117,65.77a64.646,64.646,0,0,1-6.5,7.187c-.341-1.089-.569-2.081-.569-2.081C44.41,71.282,52.117,65.77,52.117,65.77Z",
    transform: "translate(28.21 41.178)",
    fill: "#aca5b5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M88.346,59.357a19.055,19.055,0,0,1,.878,3.252A24.243,24.243,0,0,1,84.59,54.17a16.715,16.715,0,0,0,6.325,6.78,26.7,26.7,0,0,1-2.569-1.593Z",
    transform: "translate(52.989 33.917)",
    fill: "#aca5b5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M61.246,69.453l2.423,3.626c-3.9,3.089-10.813,7.154-14.634,7.675s-6.179-.1-6.585-2.374c-.325-1.74,2.764-4.715,4.26-6.049.455-.423.78-.667.78-.667l.78,1.626s-4.5,4.65-1.48,5.2H47.1c3.642.293,14-9.463,14-9.463",
    transform: "translate(26.594 43.218)",
    fill: "#34254c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M46.108,77.544h0s-2.78.228-2.667-1.837a10.585,10.585,0,0,1,2.537-4.39c.455-.423.78-.667.78-.667l.78,1.626S43.084,76.991,46.108,77.544Z",
    transform: "translate(27.228 44.232)",
    fill: "#51347f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M100.3,69.717a11.381,11.381,0,0,1-3.919,3.252c-4.878,2.764-14.862.488-14.862.488L80.38,68.091a27.236,27.236,0,0,0,12.8,2.992,12.049,12.049,0,0,0,3.415-.667c2.2-.813,2.6-2.163,1.984-3.041-.862-1.236-6.358-.26-6.358-.26l.13-4.455a24.7,24.7,0,0,1,4.878.78A5.528,5.528,0,0,1,100.3,65.2a3.772,3.772,0,0,1,0,4.52Z",
    transform: "translate(50.354 39.231)",
    fill: "#34254c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M94.057,69.416a5.4,5.4,0,0,1-3.707.7c4.179-1.252,1.626-5.447.569-6.976A5.529,5.529,0,0,1,93.992,64.9,3.772,3.772,0,0,1,94.057,69.416Z",
    transform: "translate(56.595 39.532)",
    fill: "#51347f"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M52.358,34.707s-7.577,3.4-6.618,20.309,14.8,25.707,14.8,25.707l.244,3.577S50.017,80.934,43.936,67.146,42.6,36.4,52.066,33Z",
    transform: "translate(25.839 20.664)",
    fill: "url(#linear-gradient-13)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M76.3,28.467s9.756,3.707,14,17.04-3.35,22.585-10.91,28.585l2.455,5.74S95.162,71.7,96.479,57.508,87.958,30,78.072,24.5Z",
    transform: "translate(47.8 15.343)",
    fill: "url(#linear-gradient-14)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M100.181,84.747c0,.764-6.764,1.935-9.366,2.406a286.546,286.546,0,0,1-32.178,4.032.862.862,0,0,1-.878-.6,148.666,148.666,0,0,1-5.707-26.227c-.341-2.634-.618-5.3-.829-7.984a1.772,1.772,0,0,1,1.268-1.837A154.956,154.956,0,0,1,94.766,48.26a1.789,1.789,0,0,1,1.724,1.382C98.766,59.886,100.555,79.073,100.181,84.747Z",
    transform: "translate(32.098 30.217)",
    fill: "url(#linear-gradient-15)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M99.931,83.337c0,.78-6.764,1.935-9.366,2.423a291.168,291.168,0,0,1-32.195,4.016.862.862,0,0,1-.878-.6,151.786,151.786,0,0,1-5.707-26.211c-.325-2.65-.6-5.317-.813-7.984a1.756,1.756,0,0,1,1.268-1.837A155.706,155.706,0,0,1,94.517,46.85a1.789,1.789,0,0,1,1.724,1.4C98.517,58.476,100.305,77.663,99.931,83.337Z",
    transform: "translate(31.941 29.334)",
    fill: "url(#linear-gradient-16)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M90.25,79.556A287.1,287.1,0,0,1,58.494,83.54a1.4,1.4,0,0,1-1.447-.992A149.852,149.852,0,0,1,51.47,56.76C57.047,66.4,69.323,81.752,90.25,79.556Z",
    transform: "translate(32.256 35.537)",
    fill: "url(#linear-gradient-17)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M54.66,55.543s2.309,15.008,4.7,23.577l3.041-.455S59.847,63.673,59.148,54.47Z",
    transform: "translate(34.253 34.104)",
    fill: "url(#linear-gradient-18)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M62.29,53.788s2.146,16.26,4.228,24.13l3.561-.488s-2.585-15.252-3.252-24.39Z",
    transform: "translate(39.03 33.209)",
    fill: "url(#linear-gradient-19)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M59,55.626s.634,5.61,1.415,9.414l2.976-.423-1.415-9.4A19.023,19.023,0,0,0,59,55.626Z",
    transform: "translate(36.97 34.574)",
    fill: "url(#linear-gradient-20)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    d: "M76.946,55.746a2.7,2.7,0,1,1-2.878-2.5,2.7,2.7,0,0,1,2.878,2.5Z",
    transform: "translate(44.829 33.332)",
    fill: "url(#linear-gradient-21)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M78.064,62.786a2.683,2.683,0,1,1-2.862-2.5,2.683,2.683,0,0,1,2.862,2.5Z",
    transform: "translate(45.548 37.739)",
    fill: "url(#linear-gradient-22)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M83.569,43.337a5.512,5.512,0,1,1-1.881-3.782,5.512,5.512,0,0,1,1.881,3.782Z",
    transform: "translate(45.457 23.92)",
    fill: "url(#linear-gradient-23)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M51.495,53.887c2.52-.585,8.634-1.821,15.317-3.252a1.626,1.626,0,0,0,1.3-2.163l-1.285-4.211a1.3,1.3,0,0,0-1.48-1.024c-3.008.5-10.845,1.024-15.675,2.634-.6.2-1.252.341-.894,2.309a35.774,35.774,0,0,0,1.187,4.878,1.317,1.317,0,0,0,1.528.829Z",
    transform: "translate(30.508 27.062)",
    fill: "url(#linear-gradient-24)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M48.07,39.4a26.1,26.1,0,0,0,2.618,6.049S76.964,57.526,97.419,33.51a32.52,32.52,0,0,0-3.106-8S82.1,45.819,48.07,39.4Z",
    transform: "translate(30.128 15.975)",
    fill: "url(#linear-gradient-25)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M44.311,19.17s-5.187,2.976-5.919,3.5c-1.626,1.2,4.634,18.715,6.927,18.8a31.5,31.5,0,0,0,6.049-1.626Z",
    transform: "translate(23.903 12.007)",
    fill: "url(#linear-gradient-26)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M41.68,22.764a1.024,1.024,0,0,1-.959,1.089,1.008,1.008,0,0,1-1.089-.943,1.024,1.024,0,0,1,.959-1.089,1.008,1.008,0,0,1,1.089.943Z",
    transform: "translate(24.843 13.664)",
    fill: "#c8b8d3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4053",
    "data-name": "Path 4053",
    d: "M74.39,9.118s5.9-.764,6.829-.748c2.016,0,7.48,17.772,5.691,19.219A32.033,32.033,0,0,1,81.073,29.9Z",
    transform: "translate(46.604 5.245)",
    fill: "url(#linear-gradient-27)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4054",
    "data-name": "Path 4054",
    d: "M77.225,11.385a1.008,1.008,0,0,0,1.366.341,1.024,1.024,0,0,0,.309-1.415A1.041,1.041,0,0,0,77.468,10a1.024,1.024,0,0,0-.244,1.382Z",
    transform: "translate(48.274 6.166)",
    fill: "#c8b8d3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4055",
    "data-name": "Path 4055",
    d: "M50.464,6.7,49.83,4.587A23.9,23.9,0,0,1,64.415,0L65.635,2.75Z",
    transform: "translate(31.23 0.004)",
    fill: "url(#linear-gradient-28)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4056",
    "data-name": "Path 4056",
    d: "M102.311,37.677,89.449,41.823l-38.7,12.488c-14.975-16.26-11.382-42.65,8.374-50.7a27.491,27.491,0,0,1,2.732-.976h0C83.628-4.225,104.083,12.9,102.311,37.677Z",
    transform: "translate(26.033 0.703)",
    fill: "url(#linear-gradient-29)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4057",
    "data-name": "Path 4057",
    d: "M89.449,41.236l-38.7,12.488c-14.975-16.26-11.382-42.65,8.374-50.7a27.491,27.491,0,0,1,2.732-.976c-13.236,5.5-14.423,14.374-2.585,10.732S79.6,11.448,79.6,11.448Z",
    transform: "translate(26.033 1.29)",
    fill: "url(#linear-gradient-30)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4058",
    "data-name": "Path 4058",
    d: "M98.76,23.6A31.739,31.739,0,0,1,75.492,44.218C56.761,48.64,47.2,40.234,47.2,40.234Z",
    transform: "translate(29.583 14.78)",
    fill: "url(#linear-gradient-31)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4059",
    "data-name": "Path 4059",
    d: "M100.35,33.7A39.43,39.43,0,0,1,89.18,45.079C80.871,50.754,67.7,55.485,48.79,50.331c-8.228-15.463-3.463-31.089,8.13-38.536a26.178,26.178,0,0,1,2.732-1.528C74.025,3.258,95.618,8.836,100.35,33.7Z",
    transform: "translate(27.993 4.683)",
    fill: "url(#linear-gradient-32)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4060",
    "data-name": "Path 4060",
    d: "M89.115,43.414C80.871,49.089,67.7,53.82,48.79,48.666,40.562,33.2,45.326,17.577,56.92,10.13c-1.5,3.642-3.447,10.975-1.821,22.162C57.554,49.089,69.18,54.113,89.115,43.414Z",
    transform: "translate(27.993 6.348)",
    fill: "url(#linear-gradient-33)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4061",
    "data-name": "Path 4061",
    d: "M58.8,9.247s16.016-2.732,24.959,12a2.618,2.618,0,0,1-.715,3.5h0a2.618,2.618,0,0,1-3.789-.846A30.292,30.292,0,0,0,58.8,9.247Z",
    transform: "translate(36.845 5.67)",
    fill: "url(#linear-gradient-34)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    d: "M77.251,21.154a2.049,2.049,0,1,1-2.8-.748,2.049,2.049,0,0,1,2.8.748Z",
    transform: "translate(46.002 12.608)",
    fill: "url(#linear-gradient-35)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M102.923,94.43a30.582,30.582,0,0,1-3.35,4.032h0A100.811,100.811,0,0,0,88.7,116.1a45.626,45.626,0,0,1-3.366-5.236h0A42.1,42.1,0,0,1,90.371,99.1a47.3,47.3,0,0,0,12.553-4.667Z",
    transform: "translate(53.453 59.119)",
    fill: "#2d2244"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4064",
    "data-name": "Path 4064",
    d: "M121.389,89.853a37.739,37.739,0,0,0-23.756,14.325,21.966,21.966,0,0,0,2.862-3.5,48.551,48.551,0,0,1-12.065,4.13,48.242,48.242,0,0,1,4.878-6.5C102.137,88.194,117.1,85.3,117.1,85.3a16.747,16.747,0,0,1,4.293,4.553Z",
    transform: "translate(55.393 53.404)",
    fill: "url(#linear-gradient-36)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4065",
    "data-name": "Path 4065",
    d: "M57.323,111.973l-.309.1c-.39,2.179-.8,4.146-1.219,5.919a37.121,37.121,0,0,0-6.2-7.236,11.818,11.818,0,0,1,1.089-.813,19.514,19.514,0,0,0,2.894-2.39C55.275,109.4,56.559,111,57.323,111.973Z",
    transform: "translate(31.085 67.332)",
    fill: "#2d2244"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4066",
    "data-name": "Path 4066",
    d: "M67.105,113.339a19.512,19.512,0,0,1-2.894,2.358,11.819,11.819,0,0,0-1.089.813,53.658,53.658,0,0,0-10.13-7.252A34.829,34.829,0,0,0,28,105.29a20.585,20.585,0,0,1,1.35-3.089,25.429,25.429,0,0,1,1.626-2.537h0l.13-.179.13-.163.455-.585c.894-.13,1.935-.26,3.089-.325a34.373,34.373,0,0,1,16.5,2.764,52.813,52.813,0,0,1,15.821,12.162Z",
    transform: "translate(17.564 61.543)",
    fill: "url(#linear-gradient-37)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4067",
    "data-name": "Path 4067",
    d: "M104.1,62.082a21.513,21.513,0,0,1-2.13.943,14.634,14.634,0,0,1-1.626.488,43.737,43.737,0,0,1-4.293-7.187,16.894,16.894,0,0,0,4.016-.846A39.123,39.123,0,0,0,104.1,62.082Z",
    transform: "translate(60.163 34.737)",
    fill: "#2d2244"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4068",
    "data-name": "Path 4068",
    d: "M101.71,66.6a16.894,16.894,0,0,1-4.016.846,47.869,47.869,0,0,1-3.545-28.065h0a15.642,15.642,0,0,1,2.894-1.8,51.121,51.121,0,0,0,2.732,24.585C100.409,63.791,101.06,65.271,101.71,66.6Z",
    transform: "translate(58.519 23.531)",
    fill: "url(#linear-gradient-38)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4069",
    "data-name": "Path 4069",
    d: "M39.8,66.74a28.455,28.455,0,0,1-2.992,8.423,22.39,22.39,0,0,1-6.276.309,26.374,26.374,0,0,0,4.878-7.707A15.675,15.675,0,0,0,39.8,66.74Z",
    transform: "translate(19.148 41.785)",
    fill: "#2d2244"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4070",
    "data-name": "Path 4070",
    d: "M37.939,75.886A15.675,15.675,0,0,1,33.5,76.91c3.772-9.171,2.049-18.878,1.138-22.65a4.878,4.878,0,0,1,1.008,1.268h0a.163.163,0,0,1,0,.081h0a8.13,8.13,0,0,1,.846-3.154l.2-.325C39.191,62.553,39.045,70.341,37.939,75.886Z",
    transform: "translate(21.007 32.639)",
    fill: "url(#linear-gradient-39)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4071",
    "data-name": "Path 4071",
    d: "M51.572,53.265c2.52-.585,8.927-2.049,15.317-3.252a1.3,1.3,0,0,0,1.041-1.545l-1.008-4.878a1.317,1.317,0,0,0-1.5-1.024,124.47,124.47,0,0,0-15.691,3.5,1.3,1.3,0,0,0-.878,1.447,35.773,35.773,0,0,0,1.187,4.878,1.317,1.317,0,0,0,1.528.878Z",
    transform: "translate(30.61 26.642)",
    fill: "url(#linear-gradient-40)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4072",
    "data-name": "Path 4072",
    d: "M38.446,85.983A20.162,20.162,0,0,1,31.129,87.4a19.512,19.512,0,0,1-8.65-1.87,2.309,2.309,0,0,1-1.008.911h0a10.666,10.666,0,0,1-6.585.65c-6.5-.845-8.78-4.293-8.683-6.862A2.1,2.1,0,0,1,7.292,78.52h0a14.455,14.455,0,0,1,5.87-1.333c1.789-.114,2.276-.667,1.415-1.886a1.413,1.413,0,0,0-.146-.179c-1.089-1.057-4.667-1.106-6.7-2.179a7.366,7.366,0,0,1-3.252-6.715c0-1.4,1.3-2.2,2.976-2.455a10.667,10.667,0,0,1,5.658.829c3.447,1.626,4.683.976,4.878-.846.1-1.285-2.553-3.024-4.992-4.683a32.518,32.518,0,0,1-2.78-2.065c-2.455-2.146-.959-6.618,3.35-7.431a3.252,3.252,0,0,1,1.268,0h0c3.382.65,4.878,6.5,6.829,5.626s.569-2.878-2.472-6c-.39-.423-.813-.862-1.2-1.333-2.65-3.154-4.959-7.431-1.984-9.642a3.057,3.057,0,0,1,2.472-.472c3.772.683,9.138,6.358,12.293,13.349A30.488,30.488,0,0,0,33.487,56.2c1.187,1.626,1.724,1.463,1.951,1.2a.667.667,0,0,0,.114-.2c.813-1.2,1.317-8.959,1.756-13.87a14.254,14.254,0,0,1,.276-2.309c.6-3.789,1.886-6.65,4.211-7.252a5.057,5.057,0,0,1,1.154-.163c2.016,0,3.089,1.626,3.577,5.5a16.259,16.259,0,0,1,0,2.8c-.2,3.252-1.317,6.293-1.252,10.13,0,4.878,2.992,10.081,3.935,16.439S47.21,82.569,38.446,85.983Z",
    transform: "translate(2.825 21.046)",
    fill: "url(#linear-gradient-41)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4073",
    "data-name": "Path 4073",
    d: "M19.4,43.533c-.325,2.764-3.252,2.976-5.3,2.813-.293-.358-.569-.7-.846-1.073-2.244-2.976-3.789-6.5-1.138-8.569a3.057,3.057,0,0,1,2.472-.472c.813.992,2.472,2.26,3.61,3.772a4.878,4.878,0,0,1,1.2,3.528Z",
    transform: "translate(6.748 22.635)",
    fill: "url(#linear-gradient-42)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4074",
    "data-name": "Path 4074",
    d: "M16.357,49.389a4.569,4.569,0,0,1-5.2,3.545c-.829-.585-1.626-1.154-2.309-1.626l-.39-.423C6,48.739,7.5,44.267,11.8,43.454a3.252,3.252,0,0,1,1.268,0h0a19.82,19.82,0,0,1,2.5,3.252h0A3.74,3.74,0,0,1,16.357,49.389Z",
    transform: "translate(4.59 27.169)",
    fill: "url(#linear-gradient-43)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4075",
    "data-name": "Path 4075",
    d: "M15.861,63.562a4.147,4.147,0,0,1-1.431,0l-2.39-.585a19.739,19.739,0,0,1-4.309-1.626,7.366,7.366,0,0,1-3.252-6.715c0-1.4,1.3-2.2,2.976-2.455a18.309,18.309,0,0,0,4.878,3.252c.472.179.959.374,1.447.6,1.984.894,3.935,2.163,4.211,3.382C18.235,60.83,18.137,63.155,15.861,63.562Z",
    transform: "translate(2.825 32.671)",
    fill: "url(#linear-gradient-44)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4076",
    "data-name": "Path 4076",
    d: "M20.8,69.224h0a9.756,9.756,0,0,1-5.675.748l-.911-.1c-6.5-.845-8.78-4.293-8.683-6.862A2.1,2.1,0,0,1,6.621,61.3h0c.146,0,2.748-1.024,8.894,1.626l.553.228C21.954,65.6,23.385,67.435,20.8,69.224Z",
    transform: "translate(3.497 38.261)",
    fill: "url(#linear-gradient-45)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4077",
    "data-name": "Path 4077",
    d: "M21.681,65.54c-.163-.325-5.057-9.756,2.179-18,1.187,1.626,1.724,1.463,1.951,1.2l.146.325S19.16,58.776,21.681,65.54Z",
    transform: "translate(12.502 29.766)",
    fill: "url(#linear-gradient-46)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4078",
    "data-name": "Path 4078",
    d: "M28.177,85.958a20.162,20.162,0,0,1-7.317,1.415c15.756-3.593,13.772-18.341,11.886-22.927a28.374,28.374,0,0,1,.163-20.309c2.065-5.626.683-9.057-.2-10.488,2.016,0,3.089,1.626,3.577,5.5a16.26,16.26,0,0,1,0,2.8c-.2,3.252-1.317,6.293-1.252,10.13,0,4.878,2.992,10.081,3.935,16.439S36.941,82.544,28.177,85.958Z",
    transform: "translate(13.094 21.071)",
    fill: "url(#linear-gradient-47)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4079",
    "data-name": "Path 4079",
    d: "M33.874,41.944a9.106,9.106,0,0,1-9.024-.878c.6-3.789,1.886-6.65,4.211-7.252,2.78-.7,4.163.748,4.732,5.333A16.259,16.259,0,0,1,33.874,41.944Z",
    transform: "translate(15.592 21.069)",
    fill: "url(#linear-gradient-48)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4080",
    "data-name": "Path 4080",
    d: "M18.426,42.063c-.325,2.764-5.512,4.114-6.146,1.74.52-5.089,3.4-5.463,4.878-5.268a4.878,4.878,0,0,1,1.268,3.528Z",
    transform: "translate(7.724 24.105)",
    fill: "url(#linear-gradient-49)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M15.865,48.592c-.114,4.1-5.984,4.634-7.512,1.87a4.26,4.26,0,0,1,.667-4.244c2.553-3.252,5.967-.407,6.1-.293h0a5.008,5.008,0,0,1,.748,2.667Z",
    transform: "translate(5.082 27.966)",
    fill: "url(#linear-gradient-50)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4082",
    "data-name": "Path 4082",
    d: "M13.072,62.085a4.146,4.146,0,0,1-1.431,0L9.251,61.5a6.894,6.894,0,0,1,1.626-6.959c1.984.894,3.935,2.163,4.211,3.382C15.446,59.353,15.348,61.678,13.072,62.085Z",
    transform: "translate(5.614 34.148)",
    fill: "url(#linear-gradient-51)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4083",
    "data-name": "Path 4083",
    d: "M17.429,68.447h0a9.756,9.756,0,0,1-5.675.748,5.48,5.48,0,0,1-.7-4.163,4.878,4.878,0,0,1,1.626-2.683C18.583,64.822,20.014,66.659,17.429,68.447Z",
    transform: "translate(6.867 39.037)",
    fill: "url(#linear-gradient-52)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4084",
    "data-name": "Path 4084",
    d: "M111.058,74.7a20.455,20.455,0,0,0,7.447,0,19.512,19.512,0,0,0,8.13-3.447,2.406,2.406,0,0,0,1.154.7h0a10.666,10.666,0,0,0,6.5-.6c6.211-2.032,7.837-5.837,7.268-8.358a2.1,2.1,0,0,0-1.4-1.463h0a14.179,14.179,0,0,0-6.016-.228c-1.789.211-2.358-.228-1.74-1.626a1.219,1.219,0,0,1,.114-.2c.862-1.236,4.374-1.951,6.162-3.4a7.349,7.349,0,0,0,1.984-7.2c-.293-1.366-1.626-1.919-3.366-1.854a10.683,10.683,0,0,0-5.415,1.87c-3.089,2.179-4.423,1.821-4.878,0-.325-1.236,1.951-3.447,4.016-5.545a26.936,26.936,0,0,0,2.26-2.439c2.016-2.569-.276-6.683-4.667-6.667a3.366,3.366,0,0,0-1.252.228h0c-3.252,1.268-3.528,7.219-5.658,6.8-2.39-.5-1.106-2.715,1.3-6.358a13.452,13.452,0,0,0,.943-1.626c2.016-3.577,3.5-8.13.163-9.756a3.089,3.089,0,0,0-2.52,0c-3.577,1.382-7.789,7.951-9.593,15.414a31.5,31.5,0,0,1-1.724,5.5c-.846,1.87-1.431,1.756-1.626,1.626a.472.472,0,0,1-.146-.163c-1.024-1.041-2.959-8.553-4.309-13.3-.211-.78-.455-1.512-.7-2.211-1.3-3.626-3.089-6.211-5.48-6.358a6.683,6.683,0,0,0-1.171,0c-1.984.341-2.748,2.146-2.488,6.081a14.485,14.485,0,0,0,.439,2.748c.813,3.252,2.455,5.951,3.122,9.756.829,4.878-1.089,10.455-.829,16.878S101.822,72.964,111.058,74.7Z",
    transform: "translate(59.074 14.57)",
    fill: "url(#linear-gradient-53)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M109.137,31.688c.829,2.65,3.821,2.293,5.723,1.756.228-.39.439-.78.634-1.2,1.626-3.35,2.488-7.171-.472-8.618a3.089,3.089,0,0,0-2.52,0c-.6,1.138-2,2.683-2.845,4.374a4.976,4.976,0,0,0-.52,3.691Z",
    transform: "translate(68.263 14.626)",
    fill: "url(#linear-gradient-54)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4086",
    "data-name": "Path 4086",
    d: "M113.463,36.685a4.553,4.553,0,0,0,5.837,2.52c.715-.715,1.415-1.431,1.967-2.065l.293-.374c2.016-2.569-.276-6.683-4.667-6.667a3.366,3.366,0,0,0-1.252.228h0a20.389,20.389,0,0,0-1.87,3.61h0a3.675,3.675,0,0,0-.309,2.748Z",
    transform: "translate(70.978 18.848)",
    fill: "url(#linear-gradient-55)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4087",
    "data-name": "Path 4087",
    d: "M118.071,50.719a4.634,4.634,0,0,0,1.382-.341l2.244-1.024a19.35,19.35,0,0,0,3.919-2.374,7.349,7.349,0,0,0,1.984-7.2c-.293-1.366-1.626-1.919-3.366-1.854a19.024,19.024,0,0,1-4.114,4.032c-.439.26-.878.553-1.317.862-1.789,1.252-3.463,2.862-3.512,4.114C115.258,48.475,115.795,50.735,118.071,50.719Z",
    transform: "translate(72.207 23.742)",
    fill: "url(#linear-gradient-56)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4088",
    "data-name": "Path 4088",
    d: "M115.523,57.251h0a9.658,9.658,0,0,0,5.707-.325c.276-.081.585-.163.878-.276,6.211-2.032,7.837-5.837,7.268-8.358a2.1,2.1,0,0,0-1.4-1.463h0c-.163,0-2.878-.5-8.455,3.252l-.488.325C113.718,53.9,112.628,55.9,115.523,57.251Z",
    transform: "translate(71.373 29.307)",
    fill: "url(#linear-gradient-57)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4089",
    "data-name": "Path 4089",
    d: "M110.327,53.654c.114-.341,3.154-10.553-5.48-17.284-.846,1.87-1.431,1.756-1.626,1.626l-.081.341S111.546,46.532,110.327,53.654Z",
    transform: "translate(64.601 22.774)",
    fill: "url(#linear-gradient-58)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4090",
    "data-name": "Path 4090",
    d: "M111.027,74.368a20.455,20.455,0,0,0,7.447,0c-16.146-.6-16.927-15.463-15.935-20.325a28.488,28.488,0,0,0-3.886-19.9C95.58,29,96.3,25.377,96.9,23.8c-1.984.341-2.748,2.146-2.488,6.081a14.486,14.486,0,0,0,.439,2.748c.813,3.252,2.455,5.951,3.122,9.756.829,4.878-1.089,10.455-.829,16.878S101.791,72.629,111.027,74.368Z",
    transform: "translate(59.105 14.905)",
    fill: "url(#linear-gradient-59)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4091",
    "data-name": "Path 4091",
    d: "M94.8,32.652a9.106,9.106,0,0,0,8.732-2.52c-1.3-3.626-3.089-6.211-5.48-6.358-2.862-.163-3.951,1.512-3.658,6.13a14.486,14.486,0,0,0,.406,2.748Z",
    transform: "translate(59.1 14.882)",
    fill: "url(#linear-gradient-60)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4092",
    "data-name": "Path 4092",
    d: "M109.138,29.992c.829,2.65,6.179,3.008,6.358.553-1.447-4.878-4.358-4.732-5.837-4.26a4.976,4.976,0,0,0-.52,3.707Z",
    transform: "translate(68.262 16.323)",
    fill: "url(#linear-gradient-61)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4093",
    "data-name": "Path 4093",
    d: "M113.449,35.924c.878,4.016,6.748,3.463,7.723.455a4.228,4.228,0,0,0-1.431-4.049c-3.106-2.65-5.935.715-6.065.846h0a4.878,4.878,0,0,0-.228,2.748Z",
    transform: "translate(70.992 19.61)",
    fill: "url(#linear-gradient-62)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4094",
    "data-name": "Path 4094",
    d: "M118.071,48.82a4.634,4.634,0,0,0,1.382-.341l2.244-1.024a6.911,6.911,0,0,0-2.894-6.5c-1.789,1.252-3.463,2.862-3.512,4.114C115.258,46.576,115.795,48.836,118.071,48.82Z",
    transform: "translate(72.207 25.641)",
    fill: "url(#linear-gradient-63)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4095",
    "data-name": "Path 4095",
    d: "M115.523,55.878h0a9.658,9.658,0,0,0,5.707-.325,5.382,5.382,0,0,0-.114-4.276A4.732,4.732,0,0,0,119.035,49C113.718,52.528,112.628,54.528,115.523,55.878Z",
    transform: "translate(71.373 30.68)",
    fill: "url(#linear-gradient-64)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    "data-name": "Path 4096",
    d: "M97.064,169.04s-2.244-7.382-1.724-11.284,22.764-58.1,51.8-58.015Z",
    transform: "translate(59.67 62.443)",
    fill: "#aca5b5"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4097",
    "data-name": "Path 4097",
    d: "M103.339,187.76s-6.5-5.187-7.106-22.26,34.146-76.422,55.284-64.064Z",
    transform: "translate(60.273 62.454)",
    fill: "url(#linear-gradient-65)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4098",
    "data-name": "Path 4098",
    d: "M155.648,122.657v2.13a105.258,105.258,0,0,1-1.073,11.382c-.1.683-.2,1.366-.309,2.049-.585,3.545-1.35,7.252-2.341,11.089-.163.65-.341,1.317-.52,1.984a136.369,136.369,0,0,1-4.341,13.154c-.244.634-.488,1.268-.748,1.919-1.528,3.789-3.252,7.642-5.268,11.528-.309.618-.634,1.236-.959,1.854-1.756,3.252-3.707,6.667-5.837,10l-.537.829h0q-.65.39-1.317.732C117,199.437,98.445,188.9,98.38,181.16v-.26a18.37,18.37,0,0,1,.276-2.065c.439-2.455,1.382-6.325,2.715-10.959.179-.65.374-1.317.569-1.984,1.073-3.675,2.374-7.756,3.8-11.967l.683-1.935c1.512-4.325,3.252-8.748,4.878-13.008.26-.634.537-1.268.813-1.9,1.626-3.675,3.252-7.171,4.878-10.293.325-.618.667-1.236,1.008-1.837s.829-1.4,1.236-2.065a88.472,88.472,0,0,1,5.35-7.707c.472-.585.927-1.171,1.4-1.724a50.666,50.666,0,0,1,10.585-9.9c.8-.52,1.626-1.008,2.358-1.415,4.211-2.293,8.13-2.894,11.171-1.626,1.5.6,2.846,2.8,3.837,6.244.211.732.39,1.5.569,2.325A62.8,62.8,0,0,1,155.648,122.657Z",
    transform: "translate(61.622 62.517)",
    fill: "url(#linear-gradient-66)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4099",
    "data-name": "Path 4099",
    d: "M139.816,108.25l-17.886-5.5c.8-.52,1.626-1.008,2.358-1.415l15.008,4.585C139.458,106.657,139.637,107.421,139.816,108.25Z",
    transform: "translate(76.364 63.444)",
    fill: "#988ca5"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4100",
    "data-name": "Path 4100",
    d: "M145.494,117.373v2.13l-30.894-9.48c.472-.585.927-1.171,1.4-1.724Z",
    transform: "translate(71.775 67.802)",
    fill: "#988ca5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4101",
    "data-name": "Path 4101",
    d: "M147.339,126.541c-.1.683-.2,1.366-.309,2.049l-37.17-11.382c.325-.618.667-1.236,1.008-1.837Z",
    transform: "translate(68.808 72.227)",
    fill: "#988ca5"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4102",
    "data-name": "Path 4102",
    d: "M146.892,135.009c-.163.65-.341,1.317-.52,1.984l-40.032-12.26c.26-.634.537-1.268.813-1.9Z",
    transform: "translate(66.604 76.897)",
    fill: "#988ca5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4103",
    "data-name": "Path 4103",
    d: "M144.228,144.419c-.244.634-.488,1.268-.748,1.919l-40.65-12.423.683-1.935Z",
    transform: "translate(64.407 82.625)",
    fill: "#988ca5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    "data-name": "Path 4104",
    d: "M139.864,152.514c-.309.618-.634,1.236-.959,1.854L100.19,142.514c.179-.65.374-1.317.569-1.984Z",
    transform: "translate(62.755 87.977)",
    fill: "#988ca5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4105",
    "data-name": "Path 4105",
    d: "M134.219,159.39l-.537.829h0q-.65.39-1.317.732L98.35,150.545a18.376,18.376,0,0,1,.276-2.065Z",
    transform: "translate(61.603 92.954)",
    fill: "#988ca5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4106",
    "data-name": "Path 4106",
    d: "M84.769,162.183s-2.911-7.154-5.756-9.87S24.8,121.42,2.25,139.712Z",
    transform: "translate(1.445 83.624)",
    fill: "#aca5b5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4107",
    "data-name": "Path 4107",
    d: "M92.35,180.6s1.789-8.13-8.455-21.772S9.18,120.8.53,143.744Z",
    transform: "translate(0.368 84.081)",
    fill: "url(#linear-gradient-67)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4108",
    "data-name": "Path 4108",
    d: "M10,162.7c.439.537.911,1.089,1.382,1.626a104.8,104.8,0,0,0,8.032,8.26l1.626,1.4c2.667,2.39,5.593,4.8,8.764,7.154l1.626,1.219c3.593,2.569,7.463,5.106,11.642,7.512l1.789,1.008q5.366,2.992,11.382,5.658l1.919.846c3.463,1.48,7.073,2.862,10.829,4.114l.927.309h0a7.971,7.971,0,0,0,1.5-.244c17.073-3.35,24.878-23.2,20.081-29.268l-.163-.2a17.186,17.186,0,0,0-1.512-1.447c-1.886-1.626-5.041-4.049-8.992-6.829L79.2,162.654c-3.154-2.179-6.715-4.553-10.488-6.91-.569-.374-1.154-.732-1.74-1.089-3.9-2.423-7.967-4.8-12-6.976-.6-.341-1.22-.667-1.821-.976-3.545-1.87-7.024-3.561-10.276-4.878l-1.951-.8-2.26-.829a87.032,87.032,0,0,0-9.008-2.634c-.732-.179-1.447-.325-2.163-.472a50.78,50.78,0,0,0-14.6-1.041c-.959.1-1.87.211-2.732.374-4.715.878-8.13,2.845-9.756,5.74-.8,1.415-.472,3.967.927,7.268.293.7.634,1.415,1.024,2.163A63.546,63.546,0,0,0,10,162.7Z",
    transform: "translate(0.022 85.089)",
    fill: "url(#linear-gradient-68)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4109",
    "data-name": "Path 4109",
    d: "M1.854,151.479,12.358,136c-.959.1-1.87.211-2.732.374L.83,149.382C1.106,150.016,1.464,150.732,1.854,151.479Z",
    transform: "translate(0.556 85.142)",
    fill: "#988ca5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4110",
    "data-name": "Path 4110",
    d: "M6.14,162.268c.439.537.911,1.089,1.382,1.626l18.13-26.813c-.732-.179-1.447-.325-2.163-.472Z",
    transform: "translate(3.88 85.523)",
    fill: "#988ca5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4111",
    "data-name": "Path 4111",
    d: "M11.93,170.639l1.626,1.4,21.772-32.211-1.951-.8Z",
    transform: "translate(7.504 87.038)",
    fill: "#988ca5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4112",
    "data-name": "Path 4112",
    d: "M18.27,176.989l1.626,1.219,23.447-34.682c-.6-.341-1.219-.667-1.821-.976Z",
    transform: "translate(11.473 89.242)",
    fill: "#988ca5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4113",
    "data-name": "Path 4113",
    d: "M26.45,182.659l1.789,1.008,23.756-35.138c-.569-.374-1.154-.732-1.74-1.089Z",
    transform: "translate(16.594 92.303)",
    fill: "#988ca5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4114",
    "data-name": "Path 4114",
    d: "M34.52,186.246l1.919.846,22.683-33.561L57.5,152.36Z",
    transform: "translate(21.646 95.383)",
    fill: "#988ca5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4115",
    "data-name": "Path 4115",
    d: "M42.36,188.125l.927.309h0a7.971,7.971,0,0,0,1.5-.244L64.7,158.727a17.183,17.183,0,0,0-1.512-1.447Z",
    transform: "translate(26.554 98.462)",
    fill: "#988ca5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4116",
    "data-name": "Path 4116",
    d: "M216.145,171.691c-.179-.829-.358-1.626-.569-2.325-.992-3.447-2.341-5.642-3.837-6.244a9.333,9.333,0,0,0-3.447-.618,13.009,13.009,0,0,0-1.626-.244v-.081h-1.024a15.138,15.138,0,0,0-4.114.537c-6.5,1.382-12.52,5.3-18,10.471-.39-3.252-1.138-9.919-1.772-16.39a29.089,29.089,0,0,0-5.122-13.561,16.748,16.748,0,0,0-4.276-4.537s-4.146-15.658-13.9-19.366l-.553-.2-.179-.114h0a22.2,22.2,0,0,0-9.154-1.35h0a8.131,8.131,0,0,0-1.724.244h0l-.423.1a13.154,13.154,0,0,0-2.081.7h0l-.52.228h0v-.1h0v-.114h0v-.146h0a5.9,5.9,0,0,0,.228-.829h0a.96.96,0,0,0,0-.211v-1.154a1.4,1.4,0,0,1,0-.26v-1.9a3.18,3.18,0,0,0-.146-1.138,9.4,9.4,0,0,0,2.8-.894,11.382,11.382,0,0,0,3.919-3.252,3.772,3.772,0,0,0,0-4.52,5.528,5.528,0,0,0-3.073-1.756,24.2,24.2,0,0,0-4.764-.78,34.667,34.667,0,0,0-.423-4.878,1.316,1.316,0,0,0-.114-.65h0a19.055,19.055,0,0,0-.878-3.252,26.7,26.7,0,0,0,2.569,1.512,1.138,1.138,0,0,0,.228.13h.1l.146.081h0c3.707,1.935,10.244,4.585,16.26,3.252a14.633,14.633,0,0,0,1.626-.488,21.516,21.516,0,0,0,2.13-.943,16.845,16.845,0,0,0,7.284-7.219,20.715,20.715,0,0,0,5.837-.2,19.512,19.512,0,0,0,8.13-3.447,2.406,2.406,0,0,0,1.154.7h2.6l.911-.114h0l.472-.1h.114l.407-.1h.146l.39-.1h.634a1.737,1.737,0,0,0,.6-.2c6.211-2.033,7.837-5.837,7.268-8.358a2.1,2.1,0,0,0-1.4-1.463h0a14.179,14.179,0,0,0-6.016-.228c-1.789.211-2.358-.228-1.74-1.626a1.215,1.215,0,0,1,.114-.2l2.244-1.024a19.349,19.349,0,0,0,3.919-2.374,7.349,7.349,0,0,0,1.984-7.2c-.293-1.366-1.626-1.919-3.366-1.854a10.683,10.683,0,0,0-5.415,1.87c-3.089,2.179-4.423,1.821-4.878,0-.325-1.236,1.951-3.447,4.016-5.545l.146-.13a3.48,3.48,0,0,0,1.821-1.935h0l.276-.341c2.016-2.569-.276-6.683-4.667-6.667a3.366,3.366,0,0,0-1.252.228h0c-3.252,1.268-3.528,7.219-5.658,6.8-2.39-.5-1.106-2.715,1.3-6.358a13.452,13.452,0,0,0,.943-1.626.665.665,0,0,0,.081-.146,1.447,1.447,0,0,0,.553-1.057h0a.249.249,0,0,1,.13-.26h0l.114-.244v-.081a1.808,1.808,0,0,0,.114-.26h0c.114-.26.211-.52.309-.8V44.9a.913.913,0,0,0,0-.2v-.163a.684.684,0,0,0,0-.163V43.53a.7.7,0,0,1,0-.179.487.487,0,0,0,0-.163.585.585,0,0,0,0-.163.7.7,0,0,0,0-.179v-.439a.5.5,0,0,0,0-.163v-.179a.455.455,0,0,1,0-.146V41.3a.455.455,0,0,1,0-.146v-.585a.309.309,0,0,1,0-.13v-.146a.5.5,0,0,0,0-.13V40a.99.99,0,0,0,0-.2.488.488,0,0,0,0-.13.261.261,0,0,0,0-.114v-.472l-.1-.1.276.033a.374.374,0,0,0-.114-.114l-.1-.081a.439.439,0,0,0-.13-.114h-.1l-.163-.114h-.1l-.276-.146a3.089,3.089,0,0,0-2.52,0c-3.577,1.382-7.789,7.951-9.593,15.414a31.493,31.493,0,0,1-1.724,5.5c-.845,1.87-1.431,1.756-1.626,1.626a.472.472,0,0,1-.146-.163c-1.024-1.041-2.959-8.553-4.309-13.3-.211-.78-.455-1.512-.7-2.211-1.3-3.626-3.089-6.211-5.48-6.358h-1.48l-.276.1h0l-.439-.033h0l-.228.163h0a1.2,1.2,0,0,0-.211.2h0a2.388,2.388,0,0,0-.163.211h0l-.146.244h0a1.446,1.446,0,0,0-.13.276v.1a1.741,1.741,0,0,0-.114.309h0a.489.489,0,0,1-.081.325c-.081.114,0,0,0,.1v1.333a3.71,3.71,0,0,0,0,.439h0v1.967a14.485,14.485,0,0,0,.439,2.748c.813,3.252,2.455,5.951,3.122,9.756a16.521,16.521,0,0,1,.2,3.138c-.5.2-1.057.423-1.626.7a15.644,15.644,0,0,0-2.894,1.8h0l-.309.26h0l-.472.423-.146.146-.293.276-.228.244-.2.211-.26.325-.1.1-.146.2A20.114,20.114,0,0,0,149.04,62.6a16.959,16.959,0,0,0-6.618-4.618c-.276-.65-.569-1.268-.862-1.886-.8-5.512-2.276-12.764-3.577-13.723s-2.146-2.065-9.431-1.333l-.618-.406a19.629,19.629,0,0,0,.911-2.39c0-1.171.114-2.341.1-3.48a26.276,26.276,0,0,0,5.073-2.065c1.789-1.447-3.675-19.219-5.691-19.219-.7,0-4.358.439-6.016.634A29.935,29.935,0,0,0,96.423,1.824L95.61,0A23.9,23.9,0,0,0,80.976,4.588L81.431,6.1A29.04,29.04,0,0,0,67.513,31.547c-1.415.813-4.683,2.683-5.252,3.122-1.626,1.2,4.634,18.715,6.927,18.8a23.918,23.918,0,0,0,5.187-1.333c.537.732,1.106,1.431,1.626,2.13-6.634,2.569-10.845,4.715-11.382,5.561-.878,1.154.439,6.634,1.626,10.667-2.325,1.545-5.024,4.732-5.935,11.382,0,.325-.081.667-.114,1.008a3.366,3.366,0,0,0-1.35.65,4.634,4.634,0,0,0-1.089,1.236l-.2.325a4.164,4.164,0,0,0-.179.39v.1l-.146.374h0l-.146.472v.1a4.3,4.3,0,0,0-.114.488v.081a3.247,3.247,0,0,0,0,.39v.683h0a.163.163,0,0,0,0-.081h0v-.1h0l-.1-.13h0l-.163-.211h0L56.57,87.5l-.146-.146h0l-.114-.114-.276-.228h0a10.609,10.609,0,0,0-.976-.683h0a13.415,13.415,0,0,0-3.252-1.366c-1.2-4.13-2.732-7.8-2.78-11.382,0-3.837,1.057-6.8,1.252-10.13a16.261,16.261,0,0,0,0-2.8l-.1-.634V59.9a1.273,1.273,0,0,0-.081-.553v-.13a.822.822,0,0,0-.114-.5v-.081a3.253,3.253,0,0,0-.114-.423v-.1l-1.089-.862v-.1a2.52,2.52,0,0,0-.13-.374V56.7l-.146-.309h0l-.179-.293v-.081l-.2-.244h0l-.2-.211h0l-.211-.163h0l-.569-.374h0l-.26-.114H44.814c-2.325.6-3.61,3.463-4.211,7.252-.114.748-.211,1.512-.276,2.309-.439,4.878-.943,12.666-1.756,13.87a.666.666,0,0,1-.114.2c-.228.26-.764.472-1.951-1.2a30.488,30.488,0,0,1-2.715-5.089C30.635,65.254,25.269,59.579,21.5,58.9a3.057,3.057,0,0,0-2.472.472l-.244.211a.2.2,0,0,0,0,.081l-.146.13v.1a.748.748,0,0,0-.114.114l-.081.114-.1.13a.7.7,0,0,0,0,.114V60.6a.325.325,0,0,0,0,.13v.374a.585.585,0,0,0,0,.163v.374a.358.358,0,0,1,0,.13v.146a.455.455,0,0,0,0,.146v.13a.618.618,0,0,0,0,.163v.732a.471.471,0,0,0,0,.146.585.585,0,0,0,0,.163v.472l.1.276v.146l.13.325a.585.585,0,0,0,0,.146,1.626,1.626,0,0,0,0,.163v.163a.5.5,0,0,1,.081.163V65.4a.2.2,0,0,0,.081.163l.081.146v.163a.667.667,0,0,1,.081.146l.114.179a.406.406,0,0,0,0,.114c.146.244.293.488.455.715h0l.163.228h0l.163.228h0l.179.244h0a1.463,1.463,0,0,0,.732.927l.114.146c.39.472.813.911,1.2,1.333,3.041,3.122,4.715,5.073,2.472,6s-3.447-4.976-6.829-5.626h0a3.252,3.252,0,0,0-1.268,0c-4.309,1.041-5.8,5.463-3.382,7.545l.325.276h0a3.382,3.382,0,0,0,2.146,1.626l.163.114c2.439,1.626,5.089,3.4,4.992,4.683-.146,1.821-1.382,2.406-4.878.846a10.667,10.667,0,0,0-5.658-.829c-1.626.26-2.943,1.057-2.976,2.455a7.366,7.366,0,0,0,3.252,6.715,19.74,19.74,0,0,0,4.309,1.626l2.39.585a1.415,1.415,0,0,1,.146.179c.862,1.219.374,1.772-1.415,1.886a14.455,14.455,0,0,0-5.87,1.333h0a2.146,2.146,0,0,0-1.106,1.707c0,2.569,2.211,6.016,8.7,6.862h2.927a8.4,8.4,0,0,0,.927,0h2.634A.667.667,0,0,0,24.2,108h0a2.309,2.309,0,0,0,1.008-.911,18.959,18.959,0,0,0,7.024,1.821l-.2.293a30.488,30.488,0,0,0,17.544,8.569,22.39,22.39,0,0,0,6.276-.309,24.016,24.016,0,0,0,4.878-1.48s4.39,1.2,10.6-2.325h0c.569-.325,1.138-.683,1.74-1.089,0,0,.228.992.569,2.081l.244.764h0l-.13.1-.211.179c-.114.1-.276.228-.439.39-1.5,1.333-4.585,4.309-4.26,6.049s1.9,2.585,4.488,2.537l-2.341,1.415h0c-1.74,1.057-4,2.488-5.236,3.431h-.1c-2.13,1.626-3.024,4.016-6.618,6.8s-3.528,4.878-4.878,10.618c-.618,2.5-1.285,5.008-1.837,7.041-.715,2.634-1.236,4.471-1.236,4.471a21.141,21.141,0,0,0-2.455,2.829l-.081.1h0l-.1.146h0a25.435,25.435,0,0,0-1.626,2.537,20.585,20.585,0,0,0-1.35,3.089,16.893,16.893,0,0,0-.537,1.886,52.244,52.244,0,0,0-1.024,7.4c0,.992-.114,1.886-.13,2.667v2.878a17.186,17.186,0,0,0-1.626,2.26h0a25.285,25.285,0,0,0-2.26,4.6,19.772,19.772,0,0,0-1.187,5.3c-.488,6.114,6.293,23.008,7.967,27.073-13.382-3.919-28.032-5.691-38.6-.358a14.814,14.814,0,0,0-3.577,1.919l-.829.618h.1a11.859,11.859,0,0,0-1.057,1.171A9.057,9.057,0,0,0,.424,227.2c-.8,1.415-.472,3.967.927,7.268.293.7.634,1.415,1.024,2.163A63.544,63.544,0,0,0,9.985,247.8c.439.537.911,1.089,1.382,1.626a104.813,104.813,0,0,0,8.032,8.26l1.626,1.4c2.667,2.39,5.593,4.8,8.764,7.154l1.626,1.22c3.593,2.569,7.463,5.106,11.642,7.512l1.789,1.008q5.366,2.992,11.382,5.658l1.919.846c3.463,1.48,7.073,2.862,10.829,4.114l.927.309h0a7.972,7.972,0,0,0,1.5-.244c12.471-2.439,20.016-13.707,21.284-21.967v-.537a10.959,10.959,0,0,0-.488-5.431A39.869,39.869,0,0,0,86.179,245.8a53.843,53.843,0,0,0-3.528-6.976,138.666,138.666,0,0,0-.211-17.154c-.846-8.683-3.61-15.431-3.154-20.081,0,0,4.13-1.919,7.545-16.26.423-1.772.829-3.74,1.219-5.919l.309-.1c1.789-.569,10.927-3.854,14.536-11.967,4.016-9.008,8.032-10.309,10.195-8.91s11.219,10.016,24.536,9.366c0,0,.39.862,1.106,2.2h0a45.625,45.625,0,0,0,3.366,5.236,24.39,24.39,0,0,0,8.358,7.382,89.268,89.268,0,0,1,1.268,18.406c-.211,8.341.732,18.618,3.626,24.894a55.818,55.818,0,0,0,1.333,5.577,39.722,39.722,0,0,0,3.463,13.821,10.731,10.731,0,0,0,3.024,4.537l.39.374c6.163,5.61,19.105,9.658,30.357,3.707q.667-.341,1.317-.732h0l.537-.829c2.13-3.333,4.081-6.683,5.837-10,.325-.618.65-1.236.959-1.854,1.984-3.886,3.74-7.74,5.268-11.528.26-.65.5-1.285.748-1.919a136.352,136.352,0,0,0,4.341-13.154c.179-.667.358-1.333.52-1.984.992-3.837,1.756-7.545,2.341-11.089.114-.683.211-1.366.309-2.049a105.266,105.266,0,0,0,1.073-11.382c0-.732,0-1.431,0-2.13A62.8,62.8,0,0,0,216.145,171.691ZM48.554,160.976Zm25.057-39.17H73.3a1.626,1.626,0,0,1-.667-.26.8.8,0,0,1-.244-.276.667.667,0,0,1-.081-.146,1.381,1.381,0,0,1,0-.374,4.5,4.5,0,0,1,.65-1.756,8.587,8.587,0,0,1,.6-.894l.163-.211.309-.374a11.738,11.738,0,0,1,.8-.911A23.4,23.4,0,0,0,73.61,121.806Zm68.926-15.447h0s5.5-.976,6.358.26c.618.878.211,2.228-1.984,3.041a11.594,11.594,0,0,1-3.252.65c-.276-1.041-.634-2.211-1.089-3.512Z",
    transform: "translate(0.035 0.004)",
    fill: "url(#linear-gradient-69)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4117",
    "data-name": "Path 4117",
    d: "M216.145,171.691c-.179-.829-.358-1.626-.569-2.325-.992-3.447-2.341-5.642-3.837-6.244a9.333,9.333,0,0,0-3.447-.618,13.009,13.009,0,0,0-1.626-.244v-.081h-1.024a15.138,15.138,0,0,0-4.114.537c-6.5,1.382-12.52,5.3-18,10.471-.39-3.252-1.138-9.919-1.772-16.39a29.089,29.089,0,0,0-5.122-13.561,16.748,16.748,0,0,0-4.276-4.537s-4.146-15.658-13.9-19.366l-.553-.2-.179-.114h0a22.2,22.2,0,0,0-9.154-1.35h0a8.131,8.131,0,0,0-1.724.244h0l-.423.1a13.154,13.154,0,0,0-2.081.7h0l-.52.228h0v-.1h0v-.114h0v-.146h0a5.9,5.9,0,0,0,.228-.829h0a.96.96,0,0,0,0-.211v-1.154a1.4,1.4,0,0,1,0-.26v-1.9a3.18,3.18,0,0,0-.146-1.138,9.4,9.4,0,0,0,2.8-.894,11.382,11.382,0,0,0,3.919-3.252,3.772,3.772,0,0,0,0-4.52,5.528,5.528,0,0,0-3.073-1.756,24.2,24.2,0,0,0-4.764-.78,34.667,34.667,0,0,0-.423-4.878,1.316,1.316,0,0,0-.114-.65h0a19.055,19.055,0,0,0-.878-3.252,26.7,26.7,0,0,0,2.569,1.512,1.138,1.138,0,0,0,.228.13h.1l.146.081h0c3.707,1.935,10.244,4.585,16.26,3.252a14.633,14.633,0,0,0,1.626-.488,21.516,21.516,0,0,0,2.13-.943,16.845,16.845,0,0,0,7.284-7.219,20.715,20.715,0,0,0,5.837-.2,19.512,19.512,0,0,0,8.13-3.447,2.406,2.406,0,0,0,1.154.7h2.6l.911-.114h0l.472-.1h.114l.407-.1h.146l.39-.1h.634a1.737,1.737,0,0,0,.6-.2c6.211-2.033,7.837-5.837,7.268-8.358a2.1,2.1,0,0,0-1.4-1.463h0a14.179,14.179,0,0,0-6.016-.228c-1.789.211-2.358-.228-1.74-1.626a1.215,1.215,0,0,1,.114-.2l2.244-1.024a19.349,19.349,0,0,0,3.919-2.374,7.349,7.349,0,0,0,1.984-7.2c-.293-1.366-1.626-1.919-3.366-1.854a10.683,10.683,0,0,0-5.415,1.87c-3.089,2.179-4.423,1.821-4.878,0-.325-1.236,1.951-3.447,4.016-5.545l.146-.13a3.48,3.48,0,0,0,1.821-1.935h0l.276-.341c2.016-2.569-.276-6.683-4.667-6.667a3.366,3.366,0,0,0-1.252.228h0c-3.252,1.268-3.528,7.219-5.658,6.8-2.39-.5-1.106-2.715,1.3-6.358a13.452,13.452,0,0,0,.943-1.626.665.665,0,0,0,.081-.146,1.447,1.447,0,0,0,.553-1.057h0a.249.249,0,0,1,.13-.26h0l.114-.244v-.081a1.808,1.808,0,0,0,.114-.26h0c.114-.26.211-.52.309-.8V44.9a.913.913,0,0,0,0-.2v-.163a.684.684,0,0,0,0-.163V43.53a.7.7,0,0,1,0-.179.487.487,0,0,0,0-.163.585.585,0,0,0,0-.163.7.7,0,0,0,0-.179v-.439a.5.5,0,0,0,0-.163v-.179a.455.455,0,0,1,0-.146V41.3a.455.455,0,0,1,0-.146v-.585a.309.309,0,0,1,0-.13v-.146a.5.5,0,0,0,0-.13V40a.99.99,0,0,0,0-.2.488.488,0,0,0,0-.13.261.261,0,0,0,0-.114v-.472l-.1-.1.276.033a.374.374,0,0,0-.114-.114l-.1-.081a.439.439,0,0,0-.13-.114h-.1l-.163-.114h-.1l-.276-.146a3.089,3.089,0,0,0-2.52,0c-3.577,1.382-7.789,7.951-9.593,15.414a31.493,31.493,0,0,1-1.724,5.5c-.845,1.87-1.431,1.756-1.626,1.626a.472.472,0,0,1-.146-.163c-1.024-1.041-2.959-8.553-4.309-13.3-.211-.78-.455-1.512-.7-2.211-1.3-3.626-3.089-6.211-5.48-6.358h-1.48l-.276.1h0l-.439-.033h0l-.228.163h0a1.2,1.2,0,0,0-.211.2h0a2.388,2.388,0,0,0-.163.211h0l-.146.244h0a1.446,1.446,0,0,0-.13.276v.1a1.741,1.741,0,0,0-.114.309h0a.489.489,0,0,1-.081.325c-.081.114,0,0,0,.1v1.333a3.71,3.71,0,0,0,0,.439h0v1.967a14.485,14.485,0,0,0,.439,2.748c.813,3.252,2.455,5.951,3.122,9.756a16.521,16.521,0,0,1,.2,3.138c-.5.2-1.057.423-1.626.7a15.644,15.644,0,0,0-2.894,1.8h0l-.309.26h0l-.472.423-.146.146-.293.276-.228.244-.2.211-.26.325-.1.1-.146.2A20.114,20.114,0,0,0,149.04,62.6a16.959,16.959,0,0,0-6.618-4.618c-.276-.65-.569-1.268-.862-1.886-.8-5.512-2.276-12.764-3.577-13.723s-2.146-2.065-9.431-1.333l-.618-.406a19.629,19.629,0,0,0,.911-2.39c0-1.171.114-2.341.1-3.48a26.276,26.276,0,0,0,5.073-2.065c1.789-1.447-3.675-19.219-5.691-19.219-.7,0-4.358.439-6.016.634A29.935,29.935,0,0,0,96.423,1.824L95.61,0A23.9,23.9,0,0,0,80.976,4.588L81.431,6.1A29.04,29.04,0,0,0,67.513,31.547c-1.415.813-4.683,2.683-5.252,3.122-1.626,1.2,4.634,18.715,6.927,18.8a23.918,23.918,0,0,0,5.187-1.333c.537.732,1.106,1.431,1.626,2.13-6.634,2.569-10.845,4.715-11.382,5.561-.878,1.154.439,6.634,1.626,10.667-2.325,1.545-5.024,4.732-5.935,11.382,0,.325-.081.667-.114,1.008a3.366,3.366,0,0,0-1.35.65,4.634,4.634,0,0,0-1.089,1.236l-.2.325a4.164,4.164,0,0,0-.179.39v.1l-.146.374h0l-.146.472v.1a4.3,4.3,0,0,0-.114.488v.081a3.247,3.247,0,0,0,0,.39v.683h0a.163.163,0,0,0,0-.081h0v-.1h0l-.1-.13h0l-.163-.211h0L56.57,87.5l-.146-.146h0l-.114-.114-.276-.228h0a10.609,10.609,0,0,0-.976-.683h0a13.415,13.415,0,0,0-3.252-1.366c-1.2-4.13-2.732-7.8-2.78-11.382,0-3.837,1.057-6.8,1.252-10.13a16.261,16.261,0,0,0,0-2.8l-.1-.634V59.9a1.273,1.273,0,0,0-.081-.553v-.13a.822.822,0,0,0-.114-.5v-.081a3.253,3.253,0,0,0-.114-.423v-.1l-1.089-.862v-.1a2.52,2.52,0,0,0-.13-.374V56.7l-.146-.309h0l-.179-.293v-.081l-.2-.244h0l-.2-.211h0l-.211-.163h0l-.569-.374h0l-.26-.114H44.814c-2.325.6-3.61,3.463-4.211,7.252-.114.748-.211,1.512-.276,2.309-.439,4.878-.943,12.666-1.756,13.87a.666.666,0,0,1-.114.2c-.228.26-.764.472-1.951-1.2a30.488,30.488,0,0,1-2.715-5.089C30.635,65.254,25.269,59.579,21.5,58.9a3.057,3.057,0,0,0-2.472.472l-.244.211a.2.2,0,0,0,0,.081l-.146.13v.1a.748.748,0,0,0-.114.114l-.081.114-.1.13a.7.7,0,0,0,0,.114V60.6a.325.325,0,0,0,0,.13v.374a.585.585,0,0,0,0,.163v.374a.358.358,0,0,1,0,.13v.146a.455.455,0,0,0,0,.146v.13a.618.618,0,0,0,0,.163v.732a.471.471,0,0,0,0,.146.585.585,0,0,0,0,.163v.472l.1.276v.146l.13.325a.585.585,0,0,0,0,.146,1.626,1.626,0,0,0,0,.163v.163a.5.5,0,0,1,.081.163V65.4a.2.2,0,0,0,.081.163l.081.146v.163a.667.667,0,0,1,.081.146l.114.179a.406.406,0,0,0,0,.114c.146.244.293.488.455.715h0l.163.228h0l.163.228h0l.179.244h0a1.463,1.463,0,0,0,.732.927l.114.146c.39.472.813.911,1.2,1.333,3.041,3.122,4.715,5.073,2.472,6s-3.447-4.976-6.829-5.626h0a3.252,3.252,0,0,0-1.268,0c-4.309,1.041-5.8,5.463-3.382,7.545l.325.276h0a3.382,3.382,0,0,0,2.146,1.626l.163.114c2.439,1.626,5.089,3.4,4.992,4.683-.146,1.821-1.382,2.406-4.878.846a10.667,10.667,0,0,0-5.658-.829c-1.626.26-2.943,1.057-2.976,2.455a7.366,7.366,0,0,0,3.252,6.715,19.74,19.74,0,0,0,4.309,1.626l2.39.585a1.415,1.415,0,0,1,.146.179c.862,1.219.374,1.772-1.415,1.886a14.455,14.455,0,0,0-5.87,1.333h0a2.146,2.146,0,0,0-1.106,1.707c0,2.569,2.211,6.016,8.7,6.862h2.927a8.4,8.4,0,0,0,.927,0h2.634A.667.667,0,0,0,24.2,108h0a2.309,2.309,0,0,0,1.008-.911,18.959,18.959,0,0,0,7.024,1.821l-.2.293a30.488,30.488,0,0,0,17.544,8.569,22.39,22.39,0,0,0,6.276-.309,24.016,24.016,0,0,0,4.878-1.48s4.39,1.2,10.6-2.325h0c.569-.325,1.138-.683,1.74-1.089,0,0,.228.992.569,2.081l.244.764h0l-.13.1-.211.179c-.114.1-.276.228-.439.39-1.5,1.333-4.585,4.309-4.26,6.049s1.9,2.585,4.488,2.537l-2.341,1.415h0c-1.74,1.057-4,2.488-5.236,3.431h-.1c-2.13,1.626-3.024,4.016-6.618,6.8s-3.528,4.878-4.878,10.618c-.618,2.5-1.285,5.008-1.837,7.041-.715,2.634-1.236,4.471-1.236,4.471a21.141,21.141,0,0,0-2.455,2.829l-.081.1h0l-.1.146h0a25.435,25.435,0,0,0-1.626,2.537,20.585,20.585,0,0,0-1.35,3.089,16.893,16.893,0,0,0-.537,1.886,52.244,52.244,0,0,0-1.024,7.4c0,.992-.114,1.886-.13,2.667v2.878a17.186,17.186,0,0,0-1.626,2.26h0a25.285,25.285,0,0,0-2.26,4.6,19.772,19.772,0,0,0-1.187,5.3c-.488,6.114,6.293,23.008,7.967,27.073-13.382-3.919-28.032-5.691-38.6-.358a14.814,14.814,0,0,0-3.577,1.919l-.829.618h.1a11.859,11.859,0,0,0-1.057,1.171A9.057,9.057,0,0,0,.424,227.2c-.8,1.415-.472,3.967.927,7.268.293.7.634,1.415,1.024,2.163A63.544,63.544,0,0,0,9.985,247.8c.439.537.911,1.089,1.382,1.626a104.813,104.813,0,0,0,8.032,8.26l1.626,1.4c2.667,2.39,5.593,4.8,8.764,7.154l1.626,1.22c3.593,2.569,7.463,5.106,11.642,7.512l1.789,1.008q5.366,2.992,11.382,5.658l1.919.846c3.463,1.48,7.073,2.862,10.829,4.114l.927.309h0a7.972,7.972,0,0,0,1.5-.244c12.471-2.439,20.016-13.707,21.284-21.967v-.537a10.959,10.959,0,0,0-.488-5.431A39.869,39.869,0,0,0,86.179,245.8a53.843,53.843,0,0,0-3.528-6.976,138.666,138.666,0,0,0-.211-17.154c-.846-8.683-3.61-15.431-3.154-20.081,0,0,4.13-1.919,7.545-16.26.423-1.772.829-3.74,1.219-5.919l.309-.1c1.789-.569,10.927-3.854,14.536-11.967,4.016-9.008,8.032-10.309,10.195-8.91s11.219,10.016,24.536,9.366c0,0,.39.862,1.106,2.2h0a45.625,45.625,0,0,0,3.366,5.236,24.39,24.39,0,0,0,8.358,7.382,89.268,89.268,0,0,1,1.268,18.406c-.211,8.341.732,18.618,3.626,24.894a55.818,55.818,0,0,0,1.333,5.577,39.722,39.722,0,0,0,3.463,13.821,10.731,10.731,0,0,0,3.024,4.537l.39.374c6.163,5.61,19.105,9.658,30.357,3.707q.667-.341,1.317-.732h0l.537-.829c2.13-3.333,4.081-6.683,5.837-10,.325-.618.65-1.236.959-1.854,1.984-3.886,3.74-7.74,5.268-11.528.26-.65.5-1.285.748-1.919a136.352,136.352,0,0,0,4.341-13.154c.179-.667.358-1.333.52-1.984.992-3.837,1.756-7.545,2.341-11.089.114-.683.211-1.366.309-2.049a105.266,105.266,0,0,0,1.073-11.382c0-.732,0-1.431,0-2.13A62.8,62.8,0,0,0,216.145,171.691ZM48.554,160.976Zm25.057-39.17H73.3a1.626,1.626,0,0,1-.667-.26.8.8,0,0,1-.244-.276.667.667,0,0,1-.081-.146,1.381,1.381,0,0,1,0-.374,4.5,4.5,0,0,1,.65-1.756,8.587,8.587,0,0,1,.6-.894l.163-.211.309-.374a11.738,11.738,0,0,1,.8-.911A23.4,23.4,0,0,0,73.61,121.806Zm68.926-15.447h0s5.5-.976,6.358.26c.618.878.211,2.228-1.984,3.041a11.594,11.594,0,0,1-3.252.65c-.276-1.041-.634-2.211-1.089-3.512Z",
    transform: "translate(0.035 0.004)",
    opacity: 0.57,
    fill: "url(#linear-gradient-70)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Img);
export default __webpack_public_path__ + "static/media/404-img.83c5e423fd0a5e0ac3f84c12817bfd3c.svg";
export { ForwardRef as ReactComponent };